import gql from 'graphql-tag'
import fragment from './fragment'

export default gql`
	query CA_listCashBooks($filter: CashBookFilterInput, $params: ListQueryArgs) {
		cashAssist {
			listCashBooks(filter: $filter, params: $params) {
				hasNextPage
				items {
					...CashBookFragment
				}
			}
		}
	}
${fragment}`
